import { Navigate } from "../../../../../../router"
import useFolderDetailsOutletContext from "../_folder-details-context"

export default function FilePage() {
	const { folderDetails } = useFolderDetailsOutletContext()
	return folderDetails.files.length ? (
		<Navigate
			to={`/data-drive/folders/:folderId/files/:fileId`}
			params={{
				folderId: String(folderDetails.id),
				fileId: String(folderDetails.files[0].id),
			}}
		/>
	) : (
		<Navigate
			to={`/data-drive/folders/:folderId`}
			params={{ folderId: String(folderDetails.id) }}
		/>
	)
}
